import { boolean, object, string, number } from 'yup';

export const SETTINGS_SCHEMA = object({
	manual_vc_enabled: boolean(),
	manual_vc_receiver: string()
		.nullable(true)
		.transform((value) => value?.trim() || null)
		.test(
			'egyptian-phone',
			'Enter a valid Egyptian wallet number',
			function (value) {
				if (!value) return !this.parent.manual_vc_enabled;
				return /^(?:\+?20|0)?1[0125]\d{8}$/.test(value.replace(/[\s()-]/g, ''));
			}
		),
	fawry_fawry: boolean(),
	ewallet_fawry: boolean(),
	aman_accept: boolean(),
	masary_accept: boolean(),
	credit_card_accept: boolean(),
	ewallet_accept: boolean(),
	credit_card_opay: boolean(),
	ewallet_opay: boolean(),
	fawry_moneyhash: boolean(),
	credit_card_moneyhash: boolean(),
	ewallet_moneyhash: boolean(),
	moneyhash_flow_id_fawry: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	moneyhash_flow_id_card: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	moneyhash_flow_id_ewallet: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	credit_card_kashier: boolean(),
	ewallet_kashier: boolean(),
	device_limit: number(),
	device_verification_required: boolean(),
	device_limit_enforced: boolean(),
	// Bounded to match the backend validator. Negative silently DISABLES the cap
	// (the session service reads <= 0 as unlimited), and a fraction fails against
	// the integer column — both look like tightening and are not.
	max_concurrent_sessions: number().integer().min(0).max(100),
	exams_section: boolean().required(),
	id: number(),
	parent_portal: boolean(),
	phone_verification_required: boolean().required(),
	recharge_card: boolean(),
	registration_fees: number().required(),
	revision_section: boolean().required(),
	surcharge_registration_fees: number().required(),
	// Not .oneOf([...]) on purpose: yup's oneOf rejects undefined unless it is
	// listed, which would break the form in the window before the API returns the
	// field. The MenuItem set constrains the UI and the backend's schema.enum is
	// the real gate.
	sms_provider: string(),
	cequens_api_key: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	cequens_username: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	cequens_sender_name: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	theme: string(),
	landing_headline: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	landing_subheadline: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	instructor_section: boolean().nullable(true),
	subjects_section: boolean().nullable(true),
	classrooms_enabled: boolean().nullable(true),
	standalone_courses_enabled: boolean().nullable(true),
	bundles_enabled: boolean().nullable(true),
	waselchat_widget: boolean().nullable(true),
	unit_notes_enabled: boolean().nullable(true),
	unit_qa_enabled: boolean().nullable(true),
	about_us_page: boolean().nullable(true),
	terms_link: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	privacy_link: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	fb_link: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	youtube_link: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	linkedin_link: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	instagram_link: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
	video_percentages: number()
		.nullable(false)
		.max(100, 'Allowed maximum is 100')
		.min(0, 'Minimum at least 0'),
	app_wallet: boolean().nullable(true),
	meta_title: string()
		.nullable(true)
		.transform((_, value) => {
			return value === '' ? null : value;
		}),
});
